/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* --------------------------------------------------------------------------
   RAYNOVA cross-store checkout (Store A: raynova.co; Store B: raynova.site)
   TEST CONFIGURATION: one production product mapping has been supplied.
   This code is not live until the theme ZIP is uploaded and tested.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var STORE_B_ORIGIN = 'https://raynova.site';
  var VARIANT_BY_SKU = {
    'RAYNOVA-G5030': '48295438188742',
    'RAYNOVA-G5031': '48295750435014',
    'RAYNOVA-G5032': '48307841695942',
    'RAYNOVA-Y4060': '48307964772550',
    'RAYNOVA-Y4061': '48308117438662',
    'RAYNOVA-L6080': '48308137132230',
    'RAYNOVA-G2070': '48308267253958',
    'RAYNOVA-G2071': '48308351828166',
    'RAYNOVA-L4590': '48360898560198',
    'RAYNOVA-G3070': '48360901116102',
    'RAYNOVA-G3071': '48360918941894',
    'RAYNOVA-G3072': '48360932704454',
    'RAYNOVA-L5575': '48362572316870',
    'RAYNOVA-L5576': '48362573234374',
    'RAYNOVA-C1080': '48362644996294',
    'RAYNOVA-C1081': '48362644340934',
    'RAYNOVA-C1082': '48362642833606',
    'RAYNOVA-C1083': '48362641981638',
    'RAYNOVA-L9020': '48371434881222',
    'RAYNOVA-C3025': '48371449692358',
    'RAYNOVA-C3026': '48371454509254',
    'RAYNOVA-C4075': '48371490095302',
    'RAYNOVA-C4076': '48371496190150',
    'RAYNOVA-C4077': '48371499172038'

  };

  function getSelectedSku(form) {
    if (!form) return '';
    var idField = form.querySelector('[name="id"]');
    if (!idField) return '';
    if (idField.tagName === 'SELECT') {
      var option = idField.options[idField.selectedIndex];
      return option ? (option.getAttribute('data-sku') || '') : '';
    }
    return idField.getAttribute('data-sku') || '';
  }

  function getQuantity(form) {
    var field = form && form.querySelector('[name="quantity"]');
    var quantity = field ? parseInt(field.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function redirectToStoreBCart(items) {
    if (!items || !items.length) {
      window.alert('Your cart is empty. Please add a product first.');
      return;
    }

    var mapped = [];
    var missing = [];
    items.forEach(function (item) {
      var sku = item.sku || '';
      var variantId = VARIANT_BY_SKU[sku];
      if (!variantId) {
        missing.push(sku || 'SKU missing');
        return;
      }
      var qty = parseInt(item.quantity, 10);
      if (!Number.isFinite(qty) || qty < 1) qty = 1;
      mapped.push(String(variantId) + ':' + qty);
    });

    if (missing.length) {
      window.alert('Checkout is not ready for every item in your cart. Missing SKU mapping: ' + missing.join(', ') + '. Please contact RAYNOVA support.');
      return;
    }

    var target = STORE_B_ORIGIN + '/cart/' + mapped.join(',') + '?checkout';
    window.location.assign(target);
  }

  // Product-page Buy Now: send only the selected product and quantity to Store B.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-raynova-buy-now]');
    if (!button) return;
    event.preventDefault();
    var form = button.closest('form');
    var sku = getSelectedSku(form);
    var variantId = VARIANT_BY_SKU[sku];
    if (!variantId) {
      window.alert('This product is not connected to RAYNOVA checkout yet. SKU: ' + (sku || 'missing') + '.');
      return;
    }
    redirectToStoreBCart([{ sku: sku, quantity: getQuantity(form) }]);
  });

  // Cart page and cart drawer: preserve all lines and quantities when transferring checkout.
  var checkoutInProgress = false;
  function handleCheckout(event) {
    var target = event.target;
    var checkoutButton = target && target.closest ? target.closest('button[name="checkout"], input[name="checkout"], [data-raynova-checkout]') : null;
    if (!checkoutButton) return;
    var form = checkoutButton.form || checkoutButton.closest('form');
    if (form && /\/cart\/?$/.test((form.getAttribute('action') || '').split('?')[0])) {
      // This is a cart form (cart page or drawer); transfer checkout to Store B instead.
      event.preventDefault();
      event.stopPropagation();
      if (checkoutInProgress) return;
      checkoutInProgress = true;
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Could not read the Store A cart.');
          return response.json();
        })
        .then(function (cart) {
          redirectToStoreBCart((cart.items || []).map(function (item) {
            return { sku: item.sku, quantity: item.quantity };
          }));
        })
        .catch(function () {
          window.alert('We could not transfer your cart. Please try again.');
        })
        .then(function () { checkoutInProgress = false; });
    }
  }

  document.addEventListener('click', handleCheckout, true);
  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (submitter && submitter.name === 'checkout') handleCheckout({
      target: submitter,
      preventDefault: function () { event.preventDefault(); },
      stopPropagation: function () { event.stopPropagation(); }
    });
  }, true);
})();
